/**
 * Global Privacy Control (GPC) utility functions
 *
 * GPC is a browser signal that indicates a user's preference to opt out of
 * the sale or sharing of their personal information. When GPC is detected,
 * we should automatically reject marketing cookies and respect the user's
 * privacy preference.
 */

/**
 * Checks if the browser supports Global Privacy Control and if the user has enabled it
 * @returns true if GPC is supported and enabled, false otherwise
 */
export const isGPCEnabled = (): boolean => {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  // Check for the globalPrivacyControl property on navigator
  return "globalPrivacyControl" in navigator && navigator.globalPrivacyControl === true;
};
